import useSWR from "swr";
import { useState } from "react";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { fetchBlobThroughDownloadApi } from "@adora/shared/utils/download";
import { AdBuilderServerImage } from "@adora/shared/types/ad-builder-image";

const useAdBuilderImages = (adAssetGroupId: number) => {
  // TODO: We should convert this to camel case
  const { data, error, isLoading } = useSWR<AdBuilderServerImage[]>(
    `${RelativeUrl}/ad_builder_images?ad_asset_group_id=${adAssetGroupId}`,
    fetcher
  );

  return {
    images: data || [],
    isLoading,
    error: error ? "Failed to fetch original ad images" : null
  };
};

const useMutateAdBuilderImages = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadAdBuilderImages = async (
    adAssetGroupId: number,
    resizeOnly: boolean = false
  ): Promise<Blob | undefined> => {
    setIsLoading(true);
    setError(null);

    try {
      return fetchBlobThroughDownloadApi(
        `${RelativeUrl}/ad_builder_images/download?ad_asset_group_id=${adAssetGroupId}&resize_only=${resizeOnly}`
      );
    } catch (error_) {
      const errorMessage =
        error_ instanceof Error
          ? `Failed to download ad builder images: ${error_.message}`
          : "Failed to download ad builder images: unknown error";
      console.error(errorMessage);
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  return {
    downloadAdBuilderImages,
    isLoading,
    error
  };
};
export { useAdBuilderImages, useMutateAdBuilderImages };
